import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// TODO: Replace with your Firebase project configuration
// Get this from Firebase Console -> Project Settings -> General -> Your apps
const firebaseConfig = {
  apiKey: "AIzaSyC6XeLzHlCj1GPN0-l6lN_Pt5BIAME7_w4",
  authDomain: "score-my-offer.firebaseapp.com",
  projectId: "score-my-offer",
  storageBucket: "score-my-offer.firebasestorage.app",
  messagingSenderId: "366486976811",
  appId: "1:366486976811:web:293de1e7a6fc829bf02d6e",
  measurementId: "G-KEF0HC26N2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;
